import { useCallback, useEffect, useState } from "react"

import toastMessages from "stores/toastMessages"
import { ISelectOption } from "components/Select/Select"
import { FilterCategory } from "config/constants"
import { getReservationStatusLabel, ReservationStatus } from "models/Reservation"
import AssetService from "services/AssetService"

export default function useReservationStatusOptions(currentFilterCategory: FilterCategory) {
    const [options, setOptions] = useState<ISelectOption<ReservationStatus>[] | undefined>()
    const fetchOptions = useCallback(async () => {
        try {
            const statuses = await AssetService.getReservationStatuses()
            if (!statuses) return
            setOptions(statuses.list.map(s => ({ label: getReservationStatusLabel(s), value: s })))
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.reservationStatus || options) return
        fetchOptions()
    }, [fetchOptions, currentFilterCategory, options])

    return {
        reservationStatusOptions: options,
    }

}
